import * as Types from 'types';

import { receiveArtworks } from 'features/artworks/actions';
import { fetchNextPage } from 'features/lists/actions';

import { getUserWishlistListId } from './constants';
import { requestWishes } from './api';

export const fetchCurrentUserWishlist = (
  userId: number,
): Types.DefaultThunkAction => async (dispatch) => {
  let listId = getUserWishlistListId(userId);

  dispatch(
    fetchNextPage(
      listId,
      () =>
        requestWishes().then((wishes) => {
          dispatch(receiveArtworks(wishes.map((wish) => wish.artwork)));
          return wishes.map((wish) => ({
            id: wish.artwork.id,
          }));
        }),
      { refresh: true },
    ),
  );
};
